import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import api from '../helpers/apiRequester'
import { resolvePagePattern, setCurrentPage } from './currentPage'

// Routes that are not "pages" for the activity log.
const IGNORED = new Set(['/', '/login', '/auth'])

/**
 * Mounted once inside the router. On every route change it records the
 * current page pattern (for the `X-Dashboard-Page` request header) and posts
 * a page-view beacon to `/activity-page-view` for the admin User Activity
 * page. Fire-and-forget; never affects navigation.
 */
export function PageViewTracker() {
    const { pathname, search } = useLocation()

    useEffect(() => {
        if (IGNORED.has(pathname)) {
            setCurrentPage(null)
            return
        }
        const page = resolvePagePattern(pathname)
        setCurrentPage(page)
        // The api interceptor redirects to login when there is no token; do
        // not let a beacon from a half-initialised session trigger that.
        if (!window.localStorage.getItem('access')) return
        api.post('activity-page-view', { page, path: `${pathname}${search || ''}`.slice(0, 191) }).catch(() => {})
    }, [pathname, search])

    return null
}
